import React, { useCallback, useContext, useEffect, useState } from 'react';

import Modal from './components/Modal';

export const ModalContext = React.createContext();

export function ModalContextProvider({ children }) {
	const [open, setOpen] = useState(false);
	const [modalProps, setModalProps] = useState();
	const openRef = React.useRef(false);

	const onClose = useCallback(() => {
		if (openRef.current) {
			setOpen(() => {
				openRef.current = false;
				return false;
			});
		}
	}, []);
	const triggerModal = useCallback((label, defaultValue, onSave, refNode) => {
		if (refNode !== modalProps?.refNode || !openRef.current) {
			setModalProps({
				label,
				defaultValue,
				onSave,
				refNode,
				onClose
			});
			setOpen(() => {
				openRef.current = true;
				return true;
			});
		}
	}, []);

	return (
		<ModalContext.Provider value={triggerModal}>
			{children}
			{open && (
				<Modal {...modalProps} />
			)}
		</ModalContext.Provider>
	);
};

export function useModal() {
	const triggerModal = useContext(ModalContext);
	return triggerModal;
};
